module.exports = __webpack_public_path__ + "img/itx-file-type-aac.80127595.svg";